import React, { useState, useContext } from 'react';
import './PremiumPage.css'; // Make sure this path is correct
import { loadStripe } from '@stripe/stripe-js';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../App';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

// Replace 'your_publishable_key_here' with your actual Stripe publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const PremiumPage = () => {
    const navigate = useNavigate();
    const { isSignedIn, isPremiumUser } = useContext(AuthContext);

    const handleSubscribeClick = async (plan) => {
        if (!isSignedIn) {
            navigate('/signin');
            return;
        }
        if (isPremiumUser) {
            // If the user is already a premium user, fetch the Customer Portal URL
            fetchCustomerPortalUrl();
        } else {
            // Proceed with the subscription process
            try {
                const stripe = await stripePromise;
                const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/create-checkout-session`, { plan }, { withCredentials: true });
                const { sessionId } = response.data;
                const { error } = await stripe.redirectToCheckout({ sessionId });
                if (error) {
                    console.error('Stripe redirectToCheckout error:', error.message);
                }
            } catch (error) {
                console.error('An error occurred:', error);
                toast('Failed to process the subscription. Please try again.', {
                    autoClose: 5000, // 5000 milliseconds = 5 seconds
                });
            }
        }
    };

    // Function to call the backend and retrieve the Customer Portal URL
    const fetchCustomerPortalUrl = async () => {
        try {
            const response = await axios.post('/create-customer-portal-session', {}, {
                withCredentials: true
            });
            const data = response.data;
            if (data.url) {
                // Redirect the user to the Customer Portal
                window.location.href = data.url;
            } else {
                // Throw an error if no URL is returned
                throw new Error('The server did not return a URL for the customer portal.');
            }
        } catch (error) {
            // Global Axios interceptor will handle the 401 error, so no need to check it here
            console.error('Error fetching customer portal URL:', error);
            toast('Failed to redirect to the customer portal. Please try again.', {
                autoClose: 5000, // 5000 milliseconds = 5 seconds
            });
        }
    };

    return (
        <div className="premium-page">
            <h1 className="premium-title">Premium</h1>
            <p className="premium-subtitle">
                Practice interview questions and your offer is on the way!
            </p>
            <div className="promo-notification">
                <FontAwesomeIcon icon={faBell} /> Be one of the first 20 users to redeem the promo code FIRST20FREE for monthly subscription and enjoy your first month free!
            </div>
            <div className="premium-options">
                <div className="premium-option monthly">
                    <div className="premium-plan">
                        <h2>Monthly</h2><span className="billing-info">billed monthly</span>
                    </div>
                    <p className="premium-description">
                        Our monthly plan grants access to
                        <span className="highlight"> all premium features</span>,
                        the best plan for short-term subscribers.
                    </p>
                    <div className="premium-price">
                        <div>
                            <span className="price-amount">$25</span>
                            <span className="price-term">/ month</span>
                        </div>
                        <span className="price-note">Prices are marked in USD</span>
                    </div>
                    <button className="premium-subscribe" onClick={() => handleSubscribeClick('monthly')}>Subscribe</button>
                </div>
                <div className="premium-option yearly">
                    <div className="premium-plan">
                        <h2>Yearly</h2><span className="billing-info">billed yearly</span>
                    </div>
                    <p className="premium-description">
                        This plan saves you over 50% in comparison to the monthly plan.
                    </p>
                    <div className="premium-price">
                        <div>
                            <span className="price-amount">$12.5</span>
                            <span className="price-term">/ month</span>
                        </div>
                        <span className="price-note">Prices are marked in USD</span>
                    </div>
                    <button className="premium-subscribe" onClick={() => handleSubscribeClick('yearly')}>Subscribe</button>
                </div>
            </div>
            <div className="pricing-table-container">
                <table className="pricing-table">
                    <thead>
                        <tr>
                            <th>Features</th>
                            <th>Free</th>
                            <th>Premium 🔓</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Access to questions</td>
                            <td>Limited</td>
                            <td>All 15000+ Questions</td>
                        </tr>
                        <tr>
                            <td>Filter questions by position</td>
                            <td>✔️</td>
                            <td>✔️</td>
                        </tr>
                        <tr>
                            <td>Filter questions by company</td>
                            <td>×</td>
                            <td>✔️</td>
                        </tr>
                        <tr>
                            <td>AI-Powered score and feedback</td>
                            <td>5 questions</td>
                            <td>All 15000+ Questions</td>
                        </tr>
                        <tr>
                            <td>AI-Powered response enhancement</td>
                            <td>×</td>
                            <td>✔️</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <ToastContainer position="top-center" autoClose={50000} />
        </div>
    );
};

export default PremiumPage;
